import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { CreateLocationForm } from '../../CreateLocation/CreateLocationForm';
import { LocationDetails } from '../types';

interface CreateLocationDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated: (location: LocationDetails) => void;
}

export const CreateLocationDialog: React.FC<CreateLocationDialogProps> = ({ open, onClose, onCreated }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Create location</DialogTitle>
    <DialogContent>
      <CreateLocationForm onExit={onClose} onCreated={onCreated} />
    </DialogContent>
  </Dialog>
);
